import React, { CSSProperties, SyntheticEvent } from "react";

import { Dimmer, Loader } from "semantic-ui-react";

import { FormControlLabel } from "@mui/material";

import Android12Switch, { Android12SwitchProps } from "react-lib/appcon/common/Android12Switch";

// Types
type DisplayCountingProps = Pick<
  Android12SwitchProps,
  "background" | "checked" | "label" | "onChange" | "switchStyle"
> & {
  boxStyle?: CSSProperties;
  disabled?: boolean;
  formStyle?: CSSProperties;
  loaderStyle?: CSSProperties;
  loading?: boolean;
};

const LoadingSwitch = (props: DisplayCountingProps) => {
  const handleChange: Android12SwitchProps["onChange"] = (e, checked) => {
    handlePrevent(e);

    props.onChange?.(e, checked);
  };

  const handlePrevent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "100%",
        ...props.boxStyle,
      }}
    >
      <div style={{ position: "relative" }}>
        <FormControlLabel
          label=""
          style={props.formStyle}
          control={
            <Android12Switch
              background={props.background}
              checked={props.checked}
              disabled={props.disabled}
              label={props.label}
              switchStyle={props.switchStyle}
              onChange={handleChange}
            />
          }
        />
        <Dimmer
          active={props.loading}
          size="mini"
          style={{ background: "transparent", paddingRight: 0, width: "auto" }}
          inverted
        >
          <Loader size="mini" style={props.loaderStyle} inline />
        </Dimmer>
      </div>
    </div>
  );
};

LoadingSwitch.displayName = "LoadingSwitch";

export default React.memo(LoadingSwitch);
